import React from "react";

/** Label-over-value field used in detail cards. */
const InfoField = ({ label, value, mono = false, className = "" }) => (
  <div className={className}>
    <p className="mb-1 text-[11px] font-medium uppercase tracking-wider text-[#9CA3AF]">
      {label}
    </p>
    <p
      className={`text-sm text-[#111827] ${mono ? "font-mono" : ""}`}
      style={{ wordBreak: "break-word" }}
    >
      {value === null || value === undefined || value === "" ? (
        <span className="text-[#D1D5DB]">—</span>
      ) : (
        value
      )}
    </p>
  </div>
);

export default InfoField;
